module.exports = __webpack_public_path__ + "static/media/kizuna-result-2.1a3ee459.png";